export enum DatasetSource {
	None = 'None',
	OSPI = 'OSPI',
	AnnualFiling = 'AnnualFiling'
}

export const datasetEnumToString = (dataset: DatasetSource) => {
	if (dataset === DatasetSource.AnnualFiling) {
		return 'Annual Filing';
	} else if (dataset === DatasetSource.OSPI) {
		return 'OSPI';
	} else {
		return 'None';
	}
}
